var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Claimants without Email"}},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(link_to_client)",fn:function(data){return [_c('a',{staticClass:"btn btn-secondary",attrs:{"href":'/business/clients/' + data.item.id}},[_c('i',{staticClass:"fa fa-edit"})])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }